const ReleaseItemTypePolicy = {
  ReleaseItem: {
    keyFields: ["id", "isBeta"], // Use both id and isBeta to differentiate
  },
};

export default ReleaseItemTypePolicy;
